/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { LocalizedString } from 'common-typescript/types';
import { LocaleService } from 'sis-common';

@Component({
    selector: 'app-graduation-wizard-step2',
    templateUrl: './graduation-wizard-step2.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GraduationWizardStep2Component {
    @Input() stepNumber: number;
    @Input() surveyEnabled: boolean;
    @Input() surveyUrl: LocalizedString;
    @Output() surveyOpened = new EventEmitter<void>();
    @Output() forward = new EventEmitter<void>();
    @Output() back = new EventEmitter<void>();

    private readonly localeService = inject(LocaleService);

    get localizedSurveyUrl(): string {
        return this.localeService.localize(this.surveyUrl);
    }

    onForwardClick(): void {
        if (this.surveyEnabled && this.localizedSurveyUrl) {
            window.open(this.localizedSurveyUrl, '_blank');
            this.surveyOpened.emit();
        } else {
            this.forward.emit();
        }
    }
}
